import React from "react";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
var CustomCalendarHeader = function (props) {
    return (React.createElement("div", { className: "modal-header align-items-center justify-content-between primary-calendar-header-container ".concat(!props.isMandateCalendarShow ? "rounded-0" : null) },
        React.createElement("div", { className: "d-flex justify-content-between align-items-center " },
            props.icon && (React.createElement("i", { className: "".concat(props.icon, " ").concat(props.leftSideIcon) })),
            React.createElement("div", { className: "mgl-10" },
                props.title && (React.createElement("p", { className: "DMSanN_14_400", style: { marginBottom: 0 } }, props.hasOwnProperty("title") ? props.title : "")),
                props.subtitle && (React.createElement("p", { className: "DMsanR_12_300 calendar_header_subtitle" }, props.hasOwnProperty("subtitle") ? props.subtitle : "")))),
        React.createElement(EdButton, { btnTyp: "black_one", value: "", className: props.rightSideIcon, onClick: function () {
                props.setShow(false);
                setTimeout(function () {
                    if (!!(props === null || props === void 0 ? void 0 : props.closeDropdown) &&
                        typeof (props === null || props === void 0 ? void 0 : props.closeDropdown) === "function")
                        props.closeDropdown(false);
                }, 0);
            } })));
};
export default CustomCalendarHeader;
